<template>
  <div class="sync-history-wrapper">

    <!-- ══════════════════════════════════════════
         SCREEN 1: MODAL POPUP
         ทริกเกอร์: กดคูปอง / กดจ่ายเงิน (ไม่ได้ login)
    ══════════════════════════════════════════ -->
    <div v-if="screen === 'modal'" class="modal-overlay" @click.self="closeModal">
      <div class="modal-card">
        <button class="modal-close-x" @click="closeModal">✕</button>
        <img src="@/assets/images/big-logo.png" alt="makalin" class="modal-logo" />
        <h2 class="modal-title">ปลดล็อคสิทธิประโยชน์</h2>
        <p class="modal-desc">
          เชื่อมประวัติคนไข้หรือลงทะเบียน<br>
          เพื่อใช้ <strong>คูปองส่วนลด</strong> และ <strong>สะสม M-Coins</strong>
        </p>
        <button class="benefit-link" @click="showBenefits = !showBenefits">
          {{ showBenefits ? '▴' : '▾' }} ดูสิทธิประโยชน์ทั้งหมด
        </button>
        <div v-if="showBenefits" class="benefits-box">
          <p>✓ ใช้คูปองส่วนลดได้ทันที</p>
          <p>✓ สะสม M-Coins ทุกการซื้อ</p>
          <p>✓ เข้าถึงโปรโมชั่นพิเศษสำหรับสมาชิก</p>
          <p>✓ รับ 100 แต้มเมื่อเชื่อมประวัติสำเร็จ</p>
        </div>
        <button class="btn-line" @click="goTo('phone')">
          <img src="@/assets/icons/white-line.svg" alt="line" class="line-icon" />
          เชื่อมประวัติคนไข้ / ลงทะเบียน
        </button>
        <button class="btn-ghost" @click="closeModal">
          ดำเนินการต่อโดยไม่ใช้คูปองส่วนลด
        </button>
      </div>
    </div>

    <!-- ══════════════════════════════════════════
         SCREEN 2: กรอกเบอร์โทรศัพท์
    ══════════════════════════════════════════ -->
    <div v-if="screen === 'phone'" class="page-wrapper">
      <div class="page-header">
        <button class="back-btn" @click="goTo('modal')">← ย้อนกลับ</button>
        <h1>เชื่อมประวัติคนไข้</h1>
      </div>
      <div class="page-content">
        <div class="step-bar">
          <span class="step-dot active">1</span>
          <span class="step-line"></span>
          <span class="step-dot">2</span>
          <span class="step-line"></span>
          <span class="step-dot">3</span>
        </div>
        <div class="welcome-box">
          <img src="@/assets/images/big-logo.png" alt="logo" class="welcome-logo" />
          <p class="welcome-title">Welcome to M-Clinic</p>
          <p class="welcome-sub">Enter your phone number to access your coupons and rewards</p>
        </div>
        <div class="input-group">
          <label>Phone Number</label>
          <input v-model="phone" type="tel" placeholder="เช่น 0812345678"
            maxlength="10" class="text-input" @input="phoneError = ''" @keyup.enter="checkPhone" />
          <p v-if="phoneError" class="error-msg">{{ phoneError }}</p>
        </div>
        <button class="btn-primary" @click="checkPhone" :disabled="phone.length < 9">
          Verify
        </button>
      </div>
    </div>

    <!-- ══════════════════════════════════════════
         SCREEN 3: ผูกแล้ว → Account Synced
    ══════════════════════════════════════════ -->
    <div v-if="screen === 'already-linked'" class="page-wrapper">
      <div class="page-content center synced-page">
        <div class="synced-icon-wrap">⚠️</div>
        <h2 class="synced-title">Account Synced</h2>
        <p class="synced-desc">
          This phone number <strong>{{ phone }}</strong> is already<br>
          synced to a similar account in our system.<br><br>
          Please contact our agent at the clinic<br>
          for the assistance with account verification.
        </p>
        <button class="btn-back-login" @click="closeModal">Back to Login</button>
      </div>
    </div>

    <!-- ══════════════════════════════════════════
         SCREEN 4: ลงทะเบียนคนไข้ใหม่
         (เบอร์ไม่พบ → ไปหน้านี้โดยตรง ไม่มีหน้ากลาง)
    ══════════════════════════════════════════ -->
    <div v-if="screen === 'register'" class="page-wrapper">
      <div class="page-header">
        <button class="back-btn" @click="goTo('phone')">← ย้อนกลับ</button>
        <h1>ลงทะเบียนคนไข้ใหม่</h1>
      </div>
      <div class="page-content">
        <div class="step-bar">
          <span class="step-dot done">✓</span>
          <span class="step-line done"></span>
          <span class="step-dot active">2</span>
          <span class="step-line"></span>
          <span class="step-dot">3</span>
        </div>
        <p class="step-label">กรอกข้อมูลส่วนตัว</p>
        <div class="register-grid">
          <div class="input-group">
            <label>ชื่อ <span class="required">*</span></label>
            <input v-model="form.firstName" type="text" placeholder="First Name" class="text-input" />
          </div>
          <div class="input-group">
            <label>นามสกุล <span class="required">*</span></label>
            <input v-model="form.lastName" type="text" placeholder="Last Name" class="text-input" />
          </div>
        </div>
        <div class="input-group">
          <label>อีเมล <span class="required">*</span></label>
          <input v-model="form.email" type="email" placeholder="john@example.com" class="text-input" />
        </div>
        <div class="input-group">
          <label>เบอร์โทรศัพท์</label>
          <input :value="phone" type="tel" class="text-input disabled" disabled />
          <p class="input-hint-small">⚑ กรอกอัตโนมัติจากขั้นตอนก่อน ไม่สามารถแก้ไขได้</p>
        </div>
        <div class="input-group">
          <label>วันเดือนปีเกิด <span class="required">*</span></label>
          <div class="dob-row">
            <select v-model="form.dobDay" class="text-input">
              <option value="">Day</option>
              <option v-for="d in 31" :key="d" :value="d">{{ d }}</option>
            </select>
            <select v-model="form.dobMonth" class="text-input">
              <option value="">Month</option>
              <option v-for="(m, i) in months" :key="i" :value="i+1">{{ m }}</option>
            </select>
            <select v-model="form.dobYear" class="text-input">
              <option value="">Year</option>
              <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
            </select>
          </div>
        </div>
        <button class="btn-primary"
          @click="goTo('otp')"
          :disabled="!form.firstName || !form.lastName || !form.email || !form.dobDay">
          Complete Registration
        </button>
      </div>
    </div>

    <!-- ══════════════════════════════════════════
         SCREEN 5: Verify OTP
    ══════════════════════════════════════════ -->
    <div v-if="screen === 'otp'" class="page-wrapper">
      <div class="page-header">
        <button class="back-btn" @click="goTo(otpFrom === 'register' ? 'register' : 'phone')">← ย้อนกลับ</button>
        <h1>Verify Identity</h1>
      </div>
      <div class="page-content center">
        <div class="step-bar">
          <span class="step-dot done">✓</span>
          <span class="step-line done"></span>
          <span class="step-dot done">✓</span>
          <span class="step-line done"></span>
          <span class="step-dot active">3</span>
        </div>
        <div class="otp-card">
          <div class="otp-shield">🔒</div>
          <p class="otp-title">Verify Identity</p>
          <p class="otp-sub">
            We have request an OTP to verify to your phone<br>
            <strong>{{ phone }}</strong>
          </p>
          <div class="otp-input-wrapper">
            <input v-for="(digit, i) in otpDigits" :key="i"
              :ref="el => otpRefs[i] = el"
              v-model="otpDigits[i]" type="tel" maxlength="1"
              class="otp-box" :class="{ filled: digit }"
              @input="onOtpInput(i)" @keydown.backspace="onOtpBackspace(i)" />
          </div>
          <p v-if="otpError" class="error-msg center">{{ otpError }}</p>
          <button class="btn-otp-verify" @click="verifyOtp" :disabled="otpDigits.join('').length < 6">
            Verify &amp; Sync
          </button>
          <div class="resend-wrapper">
            <span v-if="resendCountdown > 0" class="resend-countdown">
              Resend OTP SMS ({{ resendCountdown }}s)
            </span>
            <button v-else class="resend-btn" @click="resendOtp">Resend OTP SMS</button>
          </div>
          <button class="change-phone-btn" @click="goTo('phone')">Change phone number</button>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════
         SCREEN 6: เชื่อมประวัติสำเร็จ
    ══════════════════════════════════════════ -->
    <div v-if="screen === 'success-link'" class="page-wrapper">
      <div class="page-content center success-page">
        <div class="success-circle">
          <svg width="80" height="80" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="40" fill="#DCFCE7"/>
            <circle cx="40" cy="40" r="30" fill="#86EFAC"/>
            <polyline points="24,42 35,53 56,30" stroke="#16A34A" stroke-width="5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2 class="success-title">All Set!</h2>
        <p class="success-desc">
          The phone number <strong>{{ phone }}</strong> is already<br>
          synced to your account in our system.
        </p>
        <div class="coins-badge">
          <img src="@/assets/icons/m-coin.svg" alt="coin" class="coin-icon" />
          <span>+100 M-Coins เข้าบัญชีของคุณแล้ว!</span>
        </div>
        <button class="btn-success-go" @click="goToCoupon">Go to Makalin Store →</button>
      </div>
    </div>

    <!-- ══════════════════════════════════════════
         SCREEN 7: ลงทะเบียนสำเร็จ
    ══════════════════════════════════════════ -->
    <div v-if="screen === 'success-register'" class="page-wrapper">
      <div class="page-content center success-page">
        <div class="success-circle">
          <svg width="80" height="80" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="40" fill="#DCFCE7"/>
            <circle cx="40" cy="40" r="30" fill="#86EFAC"/>
            <polyline points="24,42 35,53 56,30" stroke="#16A34A" stroke-width="5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2 class="success-title">ลงทะเบียนสำเร็จ!</h2>
        <p class="success-desc">
          ยินดีต้อนรับสู่ครอบครัว Makalin Clinic<br>
          คุณสามารถใช้คูปองและสะสมแต้มได้แล้ว
        </p>
        <div class="coins-badge">
          <img src="@/assets/icons/m-coin.svg" alt="coin" class="coin-icon" />
          <span>+100 M-Coins เข้าบัญชีของคุณแล้ว!</span>
        </div>
        <button class="btn-success-go" @click="goToCoupon">ไปเลือกคูปองส่วนลด →</button>
      </div>
    </div>

    <!-- Dev Nav -->
    <div class="dev-nav">
      <span>🛠</span>
      <button @click="goTo('modal')">Modal</button>
      <button @click="goTo('phone')">Phone</button>
      <button @click="goTo('already-linked')">Linked</button>
      <button @click="goTo('register')">Register</button>
      <button @click="goTo('otp')">OTP</button>
      <button @click="goTo('success-link')">✓ Link</button>
      <button @click="goTo('success-register')">✓ Reg</button>
      <span style="color:#aaa; font-size:11px; margin-left:8px">
        Demo: 090=linked | 080=register | other=OTP | OTP:000000=error
      </span>
    </div>

  </div>
</template>

<script>
import { ref, reactive, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'SyncHistoryView',
  setup() {
    const router = useRouter()
    const screen         = ref('modal')
    const phone          = ref('')
    const phoneError     = ref('')
    const showBenefits   = ref(false)
    const otpFrom        = ref('link')
    const otpDigits      = ref(['', '', '', '', '', ''])
    const otpRefs        = ref([])
    const otpError       = ref('')
    const resendCountdown = ref(60)
    let countdownTimer   = null

    const form = reactive({
      firstName: '', lastName: '', email: '',
      dobDay: '', dobMonth: '', dobYear: '',
    })

    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    const currentYear = new Date().getFullYear()
    const years = Array.from({ length: 80 }, (_, i) => currentYear - i)

    const goTo = (s) => {
      screen.value = s
      otpError.value = ''
      if (s === 'otp') { otpDigits.value = ['','','','','','']; startCountdown() }
    }
    const closeModal  = () => router.back()
    const goToCoupon  = () => router.push('/my-cart/coupon')

    // Demo numbers:
    // 0987654321 → ผูกบัญชีแล้ว → Account Synced
    // 0123456789 → มีในระบบ ยังไม่ผูก → OTP (correct = 1111)
    // เบอร์ 10 หลักอื่นๆ → ไม่พบในระบบคนไข้ → Register
    const onPhoneInput = (e) => {
      phone.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10)
      phoneError.value = ''
    }
    const checkPhone = () => {
      if (phone.value.length !== 10) {
        phoneError.value = 'กรุณากรอกเบอร์โทร 10 หลัก'
        return
      }
      if (phone.value === '0987654321') { goTo('already-linked') }
      else if (phone.value === '0123456789') { otpFrom.value = 'link'; goTo('otp') }
      else { otpFrom.value = 'register'; goTo('register') }
    }

    const onOtpInput    = (i) => { if (otpDigits.value[i] && i < 5) otpRefs.value[i+1]?.focus() }
    const onOtpBackspace = (i) => { if (!otpDigits.value[i] && i > 0) otpRefs.value[i-1]?.focus() }
    const verifyOtp = () => {
      const code = otpDigits.value.join('')
      if (!code.startsWith('1111')) { otpError.value = 'รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่'; return }
      goTo(otpFrom.value === 'register' ? 'success-register' : 'success-link')
    }
    const resendOtp = () => { otpDigits.value = ['','','','','','']; otpError.value = ''; startCountdown() }
    const startCountdown = () => {
      clearInterval(countdownTimer); resendCountdown.value = 60
      countdownTimer = setInterval(() => { resendCountdown.value--; if (resendCountdown.value <= 0) clearInterval(countdownTimer) }, 1000)
    }

    onUnmounted(() => clearInterval(countdownTimer))

    return {
      screen, phone, phoneError, showBenefits,
      form, months, years,
      otpDigits, otpRefs, otpError, otpFrom, resendCountdown,
      goTo, closeModal, goToCoupon,
      checkPhone, onPhoneInput, onOtpInput, onOtpBackspace, verifyOtp, resendOtp,
    }
  }
}
</script>

<style lang="scss" scoped>
.sync-history-wrapper { height: 100%; position: relative; font-family: 'NotoSansThai', sans-serif; }

// Modal
.modal-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,0.55); z-index: 900;
  display: flex; align-items: center; justify-content: center; padding: 16px;
}
.modal-card {
  background: #fff; border-radius: 20px; padding: 28px 24px 20px;
  width: 100%; max-width: 420px; display: flex; flex-direction: column;
  align-items: center; gap: 12px; text-align: center; position: relative;
}
.modal-close-x {
  position: absolute; top: 14px; right: 16px; background: none; border: none;
  font-size: 18px; color: #999; cursor: pointer;
}
.modal-logo { width: 80px; }
.modal-title { font-size: 22px; font-weight: bold; color: #1A1A2E; margin: 0; }
.modal-desc { font-size: 15px; color: #555; line-height: 1.6; margin: 0; }
.benefit-link {
  background: none; border: none; color: var(--secondary-color, #4A58E5);
  font-size: 13px; cursor: pointer; text-decoration: underline; padding: 0;
}
.benefits-box {
  background: #F5F7FF; border-radius: 10px; padding: 12px 16px; width: 100%; text-align: left;
  > p { font-size: 13px; color: #333; margin: 4px 0; }
}
.btn-line {
  width: 100%; padding: 14px; background: #06C755; color: #fff; border: none;
  border-radius: 10px; font-size: 16px; font-weight: bold; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 10px;
  &:hover { opacity: 0.9; }
}
.line-icon { width: 22px; height: 22px; }

// Page layout
.page-wrapper {
  height: 100%; display: flex; flex-direction: column; overflow-y: auto; padding-top: 56px;
  @media screen and (min-width: 780px) { padding-top: 0; max-width: 480px; margin: 0 auto; padding-top: 24px; }
}
.page-header {
  display: flex; align-items: center; justify-content: center;
  padding: 16px; border-bottom: 1px solid #D6E2EF; background: #fff;
  position: fixed; top: 0; left: 0; right: 0; z-index: 100;
  @media screen and (min-width: 780px) { position: relative; border-bottom: none; }
  h1 { font-size: 18px; font-weight: bold; margin: 0; }
}
.back-btn {
  position: absolute; left: 12px; background: none; border: none;
  color: var(--secondary-color, #4A58E5); font-size: 15px; cursor: pointer;
}
.page-content {
  display: flex; flex-direction: column; padding: 20px 20px 80px; gap: 16px;
  &.center { align-items: center; text-align: center; }
}

// Step bar
.step-bar { display: flex; align-items: center; justify-content: center; gap: 0; }
.step-dot {
  width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: bold; background: #E0E0E0; color: #999;
  &.active { background: var(--secondary-color, #4A58E5); color: #fff; }
  &.done { background: #22C55E; color: #fff; }
}
.step-line { height: 2px; width: 40px; background: #E0E0E0; flex-shrink: 0; &.done { background: #22C55E; } }
.step-label { font-size: 13px; color: #888; text-align: center; margin: 0; }

// Phone
.welcome-box { text-align: center; display: flex; flex-direction: column; align-items: center; gap: 6px; }
.welcome-logo { width: 64px; }
.welcome-title { font-size: 18px; font-weight: bold; color: #1A1A2E; margin: 0; }
.welcome-sub { font-size: 13px; color: #888; margin: 0; }

// Register
.register-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.dob-row { display: grid; grid-template-columns: 1fr 1.5fr 1fr; gap: 8px; }

// Form
.input-group { display: flex; flex-direction: column; gap: 6px; width: 100%;
  label { font-size: 14px; font-weight: 600; color: #333; }
}
.text-input {
  border: 1px solid #C3C3C3; border-radius: 8px; padding: 12px 14px;
  font-size: 15px; outline: none; transition: border 0.2s; width: 100%;
  box-sizing: border-box; font-family: 'NotoSansThai', sans-serif;
  &:focus { border-color: var(--secondary-color, #4A58E5); }
  &.disabled { background: #F5F5F5; color: #888; cursor: not-allowed; }
}
.required { color: #EF4444; }
.error-msg { font-size: 13px; color: #EF4444; margin: 0; &.center { text-align: center; } }
.input-hint-small { font-size: 12px; color: #aaa; margin: 0; }

// Buttons
.btn-primary {
  width: 100%; padding: 14px;
  background: linear-gradient(90deg, #4A58E5 0%, #6D2E46 100%);
  color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: bold;
  cursor: pointer; font-family: 'NotoSansThai', sans-serif;
  &:hover { opacity: 0.9; } &:disabled { background: #C3C3C3; cursor: not-allowed; }
}
.btn-ghost {
  width: 100%; padding: 14px; background: transparent; color: #888;
  border: 1px solid #D0D0D0; border-radius: 10px; font-size: 15px; cursor: pointer;
  font-family: 'NotoSansThai', sans-serif; &:hover { background: #F9F9F9; }
}

// OTP
.otp-card {
  background: #fff; border-radius: 20px; padding: 28px 24px; width: 100%; max-width: 360px;
  display: flex; flex-direction: column; align-items: center; gap: 14px; text-align: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}
.otp-shield { font-size: 40px; }
.otp-title { font-size: 20px; font-weight: bold; color: #1A1A2E; margin: 0; }
.otp-sub { font-size: 13px; color: #666; line-height: 1.6; margin: 0; }
.otp-input-wrapper { display: flex; gap: 8px; justify-content: center; }
.otp-box {
  width: 44px; height: 52px; border: 2px solid #D0D0D0; border-radius: 10px;
  text-align: center; font-size: 22px; font-weight: bold; outline: none;
  &:focus { border-color: var(--secondary-color, #4A58E5); }
  &.filled { border-color: #22C55E; background: #F0FFF4; }
}
.btn-otp-verify {
  width: 100%; padding: 13px; background: #1A1A2E; color: #fff; border: none;
  border-radius: 10px; font-size: 15px; font-weight: bold; cursor: pointer;
  font-family: 'NotoSansThai', sans-serif;
  &:disabled { background: #C3C3C3; cursor: not-allowed; }
}
.resend-wrapper { font-size: 13px; }
.resend-countdown { color: #999; }
.resend-btn {
  background: none; border: none; color: var(--secondary-color, #4A58E5);
  font-size: 13px; cursor: pointer; text-decoration: underline;
  font-family: 'NotoSansThai', sans-serif;
}
.change-phone-btn {
  background: none; border: none; color: #999; font-size: 12px; cursor: pointer;
  font-family: 'NotoSansThai', sans-serif; &:hover { text-decoration: underline; }
}

// Already linked
.synced-page { padding-top: 80px; gap: 16px; }
.synced-icon-wrap { font-size: 56px; }
.synced-title { font-size: 22px; font-weight: bold; color: #92400E; margin: 0; }
.synced-desc { font-size: 14px; color: #555; line-height: 1.8; margin: 0; }
.btn-back-login {
  margin-top: 8px; padding: 12px 32px; background: #1A1A2E; color: #fff; border: none;
  border-radius: 10px; font-size: 15px; cursor: pointer; font-family: 'NotoSansThai', sans-serif;
}

// Success
.success-page { padding-top: 80px; gap: 16px; }
.success-circle { margin-bottom: 8px; }
.success-title { font-size: 26px; font-weight: bold; color: #16A34A; margin: 0; }
.success-desc { font-size: 14px; color: #555; line-height: 1.8; margin: 0; }
.coins-badge {
  display: flex; align-items: center; gap: 10px;
  background: #FFFBEB; border: 1px solid #FCD34D; border-radius: 12px;
  padding: 12px 20px; font-size: 15px; font-weight: bold; color: #92400E;
  width: 100%; max-width: 360px; justify-content: center;
}
.coin-icon { width: 28px; height: 28px; }
.btn-success-go {
  width: 100%; max-width: 360px; padding: 14px;
  background: linear-gradient(90deg, #16A34A 0%, #15803D 100%);
  color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: bold;
  cursor: pointer; font-family: 'NotoSansThai', sans-serif; &:hover { opacity: 0.9; }
}

// Dev nav
.dev-nav {
  position: fixed; bottom: 0; left: 0; right: 0; background: #1A1A2E;
  padding: 8px 12px; display: flex; gap: 6px; flex-wrap: wrap; align-items: center; z-index: 9999;
  > span { color: #fff; font-size: 12px; }
  > button {
    background: #4A58E5; color: #fff; border: none; border-radius: 6px;
    padding: 4px 10px; font-size: 12px; cursor: pointer; &:hover { opacity: 0.8; }
  }
}
</style>
